import { Comparativo } from "./landing/Comparativo";
import { ComoFunciona } from "./landing/ComoFunciona";
import { Faq } from "./landing/Faq";
import { Hero } from "./landing/Hero";
import { Lojas } from "./landing/Lojas";
import { Manifesto } from "./landing/Manifesto";
import { Precos } from "./landing/Precos";
import { Recursos } from "./landing/Recursos";
import { Seguranca } from "./landing/Seguranca";
import { CtaFinal, SiteFooter, SiteHeader } from "./landing/SiteChrome";
import "./landing/landing.css";

export function LandingPage(): JSX.Element {
  return (
    <div id="topo" className="lp flex min-h-[100dvh] flex-col bg-background text-foreground">
      <a
        href="#conteudo"
        className="sr-only z-50 rounded-md bg-signal px-4 py-2 font-semibold text-signal-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
      >
        Pular para o conteúdo
      </a>
      <SiteHeader />
      <main id="conteudo" className="flex-1">
        <Hero />
        <Manifesto />
        <ComoFunciona />
        <Recursos />
        <Lojas />
        <Seguranca />
        <Comparativo />
        <Precos />
        <Faq />
        <CtaFinal />
      </main>
      <SiteFooter />
    </div>
  );
}
